<script>
    import userService from "../user/service.svelte.js";
    import BreadCrumNav from "../../components/breadcrum-nav.svelte";
    import { user, token } from "../user/user.state.svelte.js";
    import { format } from "svelte-i18n";
    import { tick } from "svelte";

    let loggedUser;
    let formData = {
        new_password: "",
        repeatPassword: "",
    };

    let userPromise = userService
        .getLoggedUser()
        .then((pUser) => (loggedUser = pUser))
        .catch((e) => {
            return {
                show_welcome_msg: false,
                terms_and_conditions_accepted: true,
            };
        });

    let formIsSubmitted = false;
    // API 422 errors
    let formApiErrors = {};
    //API password errors
    let APIerror = $state(null);
    let tooltipID = $state();
    let viewerTooltipID = $state();

    let notifications_enabled = $state(user.data.is_notification_enabled);

    const handleNotificationsChange = () => {
        notifications_enabled = !notifications_enabled;
        let data = {
            is_notification_enabled: notifications_enabled,
        };
        userService
            .patchOwnUSer(data)
            .then((user) => {
                return true;
            })
            .catch((errors) => {
                return false;
            });
    };

    const handleCopy = async (str, tooltip) => {
        copyText(str, tooltip);
    };

    const sha512 = async (str) => {
        const buffer = new TextEncoder().encode(str);
        const hashBuffer = await crypto.subtle.digest("SHA-512", buffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    };

    const handleCopyViewerToken = async (rawToken, tooltip) => {
        if (!rawToken) return;

        const colonIndex = rawToken.indexOf(":");
        let viewerToken = rawToken;

        if (colonIndex !== -1) {
            const leftPart = rawToken.slice(0, colonIndex);
            const rightPart = rawToken.slice(colonIndex + 1);
            const hashedRightPart = await sha512(rightPart);
            viewerToken = `${leftPart}:viewer-${hashedRightPart}`;
        }

        copyText(viewerToken, tooltip);
    };

    const copyText = async (str, tooltip) => {
        await tick();
        if ("clipboard" in navigator) {
            navigator.clipboard
                .writeText(str)
                .then(() => {
                    showTooltip(tooltip);
                    hideTooltip(tooltip);
                })
                .catch((err) => console.error(err.name, err.message));
        } else {
            let selBox = document.createElement("textarea");
            selBox.style.position = "fixed";
            selBox.style.left = "0";
            selBox.style.top = "0";
            selBox.style.opacity = "0";
            selBox.value = str;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            // @TODO: upgrade to clipboard API
            try {
                const success = document.execCommand("copy");
            } catch (err) {
                return false;
            }
            showTooltip(tooltip);
            document.body.removeChild(selBox);
            hideTooltip(tooltip);
        }
    };

    const hideTooltip = (tooltip) => {
        setTimeout(() => {
            tooltip.classList.add("trigger-opacity-cero");
            tooltip.classList.remove("trigger-opacity-one");
            setTimeout(() => tooltip.classList.add("d-none"), 1000);
        }, 2000);
    };

    const showTooltip = (tooltip) => {
        tooltip.classList.remove("d-none");
        setTimeout(() => {
            tooltip.classList.remove("trigger-opacity-cero");
            tooltip.classList.add("trigger-opacity-one");
        }, 1000);
    };
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-user fa-xs"></i>
                    {#await userPromise then usr}
                        {usr.email}
                    {/await}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav
                    routes={[{ label: $format("components.breadcrumb.me") }]}
                />
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 d-lg-flex">
                <div class="card user-data">
                    <div class="card-header">
                        <div class="card-title">
                            {$format("data")}
                        </div>
                    </div>
                    <div class="card-body">
                        {#await userPromise then usr}
                            <p><strong>Email</strong></p>
                            <p class="text-muted">
                                {usr.email || ""}
                            </p>
                            <p><strong>{$format("page.me.role")}</strong></p>
                            <p class="text-muted">
                                {$format(`page.user.roles.${usr.role}`)}
                            </p>
                            {#if !usr.terms_and_conditions_accepted}
                                <div class="change-password-ad card">
                                    {$format("page.me.new_user_msg")}
                                </div>
                            {/if}
                            <div class="mb-3">
                                <div class="form-check form-switch">
                                    <input
                                        type="checkbox"
                                        bind:checked={notifications_enabled}
                                        onclick={handleNotificationsChange}
                                        class="form-check-input"
                                        id="notifications-checkbox"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="notifications-checkbox"
                                    ></label>{$format(
                                        "page.me.enable_notifications",
                                    )}
                                </div>
                            </div>
                            <div class="mb-3">
                                <button
                                    class="btn btn-default"
                                    title="Copiar al portapapeles"
                                    aria-label="Copiar"
                                    onclick={() =>
                                        handleCopy(token.access_token, tooltipID)}
                                >{$format(
                                        "buttons.copy_access_token",
                                    )}</button>
                                <span
                                    id="tooltip-compose"
                                    class="d-none trigger-opacity-cero copy-tooltip"
                                    bind:this={tooltipID}
                                    >{$format("copied")}</span
                                >
                            </div>
                            <!-- <div class="mb-3">
                                <button
                                    class="btn btn-default"
                                    title="Copiar al portapapeles"
                                    aria-label="Copiar viewer token"
                                    onclick={() =>
                                        handleCopyViewerToken(token.access_token, viewerTooltipID)}
                                >{$format(
                                        "buttons.copy_viewer_token",
                                    )}</button>
                                <span
                                    id="tooltip-viewer"
                                    class="d-none trigger-opacity-cero copy-tooltip"
                                    bind:this={viewerTooltipID}
                                    >{$format("copied")}</span
                                >
                            </div> -->
                        {/await}
                    </div>
                    {#await userPromise}
                        <div class="overlay">
                            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>
                    {/await}
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .hiddenInput {
        display: none;
    }
    .user-data {
        flex: 3;
    }
    .change-password {
        flex: 1;
    }
    .change-password-ad {
        right: 0;
        top: 0;
        text-align: center;
        /*font-size: 1.25em;*/
        position: absolute;
        background: rgb(0, 0, 0, 0.8);
        border-radius: 5px;
        color: white;
        padding: 15px;
        border-top-right-radius: 0px;
    }
    .change-password-ad::after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 11px solid rgba(0, 0, 0, 0.8);
        position: absolute;
        top: 4px;
        right: -15px;
        transform: rotate(268deg);
    }
</style>